import { SignedIn, SignedOut } from '@clerk/clerk-react';
import { Navigate, useLocation } from 'react-router-dom';

import useClerkLoginState from '../../utils/useClerkLoginState';
import LoadingContainer from '../LoadingContainer';

export default function PrivateRouteComponent({ children }) {
	const state = useClerkLoginState();
	const location = useLocation();

	// Allow onboarding users to access certain pages during onboarding
	const onboardingAllowedPaths = ['/channels', '/inventory', '/insights', '/dashboard'];
	const isOnboardingAllowedPath = onboardingAllowedPaths.some((path) => location.pathname.startsWith(path));

	return (
		<>
			<SignedOut>
				<Navigate to="/login" />
			</SignedOut>
			<SignedIn>
				{(!state || state === 'loading') && <LoadingContainer />}
				{state === 'logged-in' && children}
				{state === 'no-organisation-unify' && <Navigate to="/unify-onboarding" />}
				{state === 'unify-onboarding-incomplete' && (isOnboardingAllowedPath ? children : <Navigate to="/unify-onboarding" />)}
				{state === 'no-organisation' && (
					<>
						<p>You&apos;re not connected to any retailer accounts.</p>
					</>
				)}
			</SignedIn>
		</>
	);
}
